import { notification } from "antd";
import axiosInstance from "../axiosInstance";
import { User } from "../../types/user";

const getUsers = async (): Promise<User[]> => {
  try {
    const response = await axiosInstance.get<User[]>("/user");
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível obter os usuários.",
    });

    throw new Error(`${error}`);
  }
};

const updatePermission = async (
  id: string,
  permission: string
): Promise<User> => {
  try {
    const response = await axiosInstance.patch<User>(
      `/user/update-permission/${id}`,
      { permission }
    );
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Não foi possível atualizar a permissão.",
    });

    throw new Error(`${error}`);
  }
};

const updatePassword = async (
  password: string,
  confirm_password: string
): Promise<User> => {
  try {
    const response = await axiosInstance.patch<User>(`/user/update-password/`, {
      password,
      confirm_password,
    });
    return response.data;
  } catch (error) {
    notification.error({
      message: "Erro",
      description: "Senhas precisam coincidir e precisam ter, no mínimo, 7 caracteres.",
    });

    throw new Error(`${error}`);
  }
};

export const userService = {
  getUsers,
  updatePermission,
  updatePassword
};
